export default "__VITE_ASSET__CkpuHC8a__"